<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">客户</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Keyword"
                        remote
                        filterable
                        allow-create
                        placeholder="客户名称/电话"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">销售单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.OrderCode"
                        v-filter-special-char="searchData.OrderCode"
                        placeholder="销售单号"
                    ></el-input>
                    <div class="search-name">支付方式</div>
                    <el-select class="search-item" size="small" v-model="searchData.PayType" multiple collapse-tags clearable>
                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">收款状态</div>
                    <el-select class="search-item" style="width: 120px" size="small" v-model="searchData.State">
                        <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">物流状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.DeliveryStat">
                        <el-option v-for="item in deliveryStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">业务员</div>
                    <el-select v-model="searchData.SId" class="search-item" size="small" filterable clearable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">创建日期</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <div class="search-name">确认日期</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible2 = true"></i>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button v-if="permission.print" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                        permission.print
                    }}</el-button>
                    <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
                    <el-button v-if="permission.batchConfirm" size="small" type="warning" icon="el-icon-document-copy" class="search-btn" @click="batchComfirms()"
                        >{{ permission.batchConfirm }}
                    </el-button>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>订单总数</p>
                            <p>{{ statData.saleCount }}</p>
                        </div>
                        <div class="data-item">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">订单总计 = 销售订单总额 + 总运费 - 优惠总额</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >订单总计
                            </p>
                            <p>￥{{ statData.orderTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>销售总额</p>
                            <p>￥{{ statData.saleTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>优惠总额</p>
                            <p>￥{{ statData.discountTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>运费总计</p>
                            <p>￥{{ statData.transTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>成本总计</p>
                            <p style="color: red; font-size: 16px">￥{{ statData.coseTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>利润总额</p>
                            <p style="color: green; font-size: 16px" v-if="statData.profitTotal > 0">￥{{ statData.profitTotal }}</p>
                            <p style="color: red; font-size: 16px" v-else>￥{{ statData.profitTotal }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>已收总额</p>
                            <p>￥{{ statData.receiptTotal }}</p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn salesgather-table">
                <el-table
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border
                    :data="tableData"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :row-key="getRowKeys"
                >
                    <el-table-column type="selection" reserve-selection width="55"></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.OrderCode.IsShow"
                        :width="columnShowSets.OrderCode.Width > 0 ? columnShowSets.OrderCode.Width + 'px' : '220px'"
                        :label="columnShowSets.OrderCode.ColumnName"
                        prop="OrderCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="scope.row.ApplyCount + '条待确认'" class="mark" type="danger" v-if="scope.row.ApplyCount > 0">
                                {{ scope.row.OrderCode }}
                            </el-badge>
                            {{ scope.row.ApplyCount > 0 ? '' : scope.row.OrderCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.ReturnOrderRs.IsShow"
                        :width="columnShowSets.ReturnOrderRs.Width > 0 ? columnShowSets.ReturnOrderRs.Width + 'px' : '220px'"
                        :label="columnShowSets.ReturnOrderRs.ColumnName"
                        prop="ReturnOrderRs"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.EntpCusName.IsShow"
                        :min-width="columnShowSets.EntpCusName.Width > 0 ? columnShowSets.EntpCusName.Width + 'px' : '200px'"
                        :label="columnShowSets.EntpCusName.ColumnName"
                        prop="EntpCusName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.CallNum.IsShow"
                        :min-width="columnShowSets.CallNum.Width > 0 ? columnShowSets.CallNum.Width + 'px' : '120px'"
                        :label="columnShowSets.CallNum.ColumnName"
                        prop="CallNum"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="PayTypeName"
                        v-if="columnShowSets.PayTypeName.IsShow"
                        :min-width="columnShowSets.PayTypeName.Width > 0 ? columnShowSets.PayTypeName.Width + 'px' : '100px'"
                        :label="columnShowSets.PayTypeName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="CollectionStateName"
                        v-if="columnShowSets.CollectionStateName.IsShow"
                        :width="columnShowSets.CollectionStateName.Width > 0 ? columnShowSets.CollectionStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.CollectionStateName.ColumnName"
                        show-overflow-tooltip
                        ><template slot-scope="scope">
                            <i v-if="scope.row.IsAllReturn">已全部退货 </i>
                            <i v-else-if="scope.row.CollectionStateName == '已完成收款'" class="c-active">{{ scope.row.CollectionStateName }}</i>
                            <i v-else>{{ scope.row.CollectionStateName }} </i>
                        </template></el-table-column
                    >
                    <el-table-column
                        prop="OutWarehouseStateName"
                        v-if="columnShowSets.OutWarehouseStateName.IsShow"
                        :width="columnShowSets.OutWarehouseStateName.Width > 0 ? columnShowSets.OutWarehouseStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.OutWarehouseStateName.ColumnName"
                        show-overflow-tooltip
                        ><template slot-scope="scope">
                            <i v-if="scope.row.OutWarehouseStateName == '已出仓'" class="out-active">{{ scope.row.OutWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.OutWarehouseStateName }}</i></template
                        ></el-table-column
                    >
                    <el-table-column
                        prop="OrderAmount"
                        v-if="columnShowSets.OrderAmount.IsShow"
                        :min-width="columnShowSets.OrderAmount.Width > 0 ? columnShowSets.OrderAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.OrderAmount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="DiscountAmount"
                        v-if="columnShowSets.DiscountAmount.IsShow"
                        :min-width="columnShowSets.DiscountAmount.Width > 0 ? columnShowSets.DiscountAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.DiscountAmount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ShipAmount"
                        v-if="columnShowSets.ShipAmount.IsShow"
                        :min-width="columnShowSets.ShipAmount.Width > 0 ? columnShowSets.ShipAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.ShipAmount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.CalcAmount.IsShow"
                        :width="columnShowSets.CalcAmount.Width > 0 ? columnShowSets.CalcAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.CalcAmount.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{ (scope.row.OrderAmount + scope.row.ShipAmount - scope.row.DiscountAmount).toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column
                        prop="TotalCost"
                        v-if="columnShowSets.TotalCost.IsShow"
                        :min-width="columnShowSets.TotalCost.Width > 0 ? columnShowSets.TotalCost.Width + 'px' : '100px'"
                        :label="columnShowSets.TotalCost.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.TotalProfit.IsShow"
                        :width="columnShowSets.TotalProfit.Width > 0 ? columnShowSets.TotalProfit.Width + 'px' : '100px'"
                        :label="columnShowSets.TotalProfit.ColumnName"
                        show-overflow-tooltip
                        ><template slot-scope="scope">{{
                            (scope.row.OrderAmount + scope.row.ShipAmount - scope.row.DiscountAmount - scope.row.TotalCost).toFixed(2)
                        }}</template></el-table-column
                    >
                    <el-table-column
                        prop="ReturnMoney"
                        v-if="columnShowSets.ReturnMoney.IsShow"
                        :min-width="columnShowSets.ReturnMoney.Width > 0 ? columnShowSets.ReturnMoney.Width + 'px' : '100px'"
                        :label="columnShowSets.ReturnMoney.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Paid"
                        v-if="columnShowSets.Paid.IsShow"
                        :min-width="columnShowSets.Paid.Width > 0 ? columnShowSets.Paid.Width + 'px' : '100px'"
                        :label="columnShowSets.Paid.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="SName"
                        v-if="columnShowSets.SName.IsShow"
                        :min-width="columnShowSets.SName.Width > 0 ? columnShowSets.SName.Width + 'px' : '80px'"
                        :label="columnShowSets.SName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        sortable
                        v-if="columnShowSets.CreateTime.IsShow"
                        :min-width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                        :label="columnShowSets.CreateTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <el-button
                                v-if="permission.saleGatheringFunc && (scope.row.IsDelivery || scope.row.ApplyCount > 0) && !scope.row.IsCanStateBack"
                                :title="permission.saleGatheringFunc"
                                size="mini"
                                type="text"
                                @click="add('creceipt', scope.row)"
                                >{{ permission.saleGatheringFunc }}</el-button
                            >
                            <el-button
                                v-else-if="permission.editAndConfirm && scope.row.IsCanCollect && scope.row.ApplyCount > 0 && !scope.row.IsCanStateBack"
                                :title="permission.saleGatheringFunc"
                                size="mini"
                                type="text"
                                @click="add('creceipt', scope.row)"
                                >{{ permission.editAndConfirm }}</el-button
                            >
                            <!--当订单无申请收付款记录时弹窗完成付款-->
                            <el-button
                                v-else-if="permission.editAndConfirm && scope.row.IsCanCollect && scope.row.ApplyCount == 0 && !scope.row.IsCanStateBack"
                                :title="permission.saleGatheringFunc"
                                size="mini"
                                type="text"
                                @click="finishAndEditReceipt(scope.row)"
                                >{{ permission.editAndConfirm }}</el-button
                            >
                            <el-button
                                v-if="permission.stateBack && scope.row.IsCanStateBack"
                                :title="permission.stateBack"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="stateBack(scope.row)"
                                >{{ permission.stateBack }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
                <div class="dialog-content" v-if="statisticsVisible">
                    <statistics :countData="multipleSelection" type="sale" pageName="salesOrderGathering"></statistics>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="确认时间" :visible.sync="timeVisible2" width="800px">
                <div class="dialog-content" v-if="timeVisible2">
                    <timePicker @timerSearch="timerSearch2" :start="this.searchData.CStartDate" :end="this.searchData.CEndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
                <div class="dialog-content" v-if="dialogVisible">
                    <printContent @closeDialog="closeDialog" :printIds="idList"></printContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="完成收款" :visible.sync="finishVisible" width="1000px">
                <div class="dialog-content" v-if="finishVisible">
                    <finishReceiptOrPayment @closeFinish="closeFinish" :finishData="finishData" :type="0"></finishReceiptOrPayment>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import finishReceiptOrPayment from '@/components/business/revenue/finishReceiptOrPayment';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        statistics,
        timePicker,
        breadcrumb,
        elTableColumn,
        finishReceiptOrPayment
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            tableCode: 'SalesOrderGathering',
            userMsg: userMsg,
            timeVisible: false,
            timeVisible2: false,
            statisticsVisible: false,
            multipleSelection: null,
            dialogVisible: false,
            searchData: {
                State: '5',
                PayType: [],
                Keyword: '',
                DeliveryStat: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            statData: {
                saleCount: 0,
                saleTotal: 0,
                discountTotal: 0,
                transTotal: 0,
                orderTotal: 0,
                coseTotal: 0,
                profitTotal: 0,
                receiptTotal: 0
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未收款', Value: '5' },
                { Text: '已收定金', Value: '10' },
                { Text: '已完成收款', Value: '15' },
                { Text: '已全部退货', Value: '20' }
            ],
            deliveryStateList: [
                { Text: '全部', Value: '' },
                { Text: '未出仓', Value: '5' },
                { Text: '部分出仓', Value: '10' },
                { Text: '已出仓', Value: '15' }
            ],
            SIdList: [],
            payWayList: [],
            idList: [],
            columnShowSets: {
                OrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnOrderRs: { ColumnName: '', IsShow: false, Width: 0 },
                EntpCusName: { ColumnName: '', IsShow: false, Width: 0 },
                CallNum: { ColumnName: '', IsShow: false, Width: 0 },
                PayTypeName: { ColumnName: '', IsShow: false, Width: 0 },
                CollectionStateName: { ColumnName: '', IsShow: false, Width: 0 },
                OutWarehouseStateName: { ColumnName: '', IsShow: false, Width: 0 },
                OrderAmount: { ColumnName: '', IsShow: false, Width: 0 },
                DiscountAmount: { ColumnName: '', IsShow: false, Width: 0 },
                ShipAmount: { ColumnName: '', IsShow: false, Width: 0 },
                CalcAmount: { ColumnName: '', IsShow: false, Width: 0 },
                TotalCost: { ColumnName: '', IsShow: false, Width: 0 },
                TotalProfit: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnMoney: { ColumnName: '', IsShow: false, Width: 0 },
                Paid: { ColumnName: '', IsShow: false, Width: 0 },
                SName: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 }
            },
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            finishVisible: false,
            finishData: { allMoney: 0, orderId: '', payType: '' }
        };
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.initSearchSelectData();

        this.getTableData();
        this.searchCustom();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('salesOrderGathering');

        let that = this;
        Vue.component('printContent', function (resolve) {
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printSales'], resolve);
                }
            });
        });
    },
    watch: {
        NeedRefresh(value) {
            if (value) {
                this.getTableData();
                this.$store.commit('updateNeedRefresh', false);
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$store.state.needRefresh;
        }
    },
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusOId;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getPay();
            this.getSIdList();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        timerSearch2(timer) {
            this.timeVisibleC = false;
            this.searchData.State = '15';
            this.searchData.CStartDate = timer.start;
            this.searchData.CEndDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
            this.dialogVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusOId);
            }
            this.idList = idList;
        },
        // 跳转编辑
        add(type, item) {
            let id = item ? item.EntpCusOId : '';
            this.$router.push(`/financeManage/salesOrder/gathering/confirmReceipt?action=${type}&id=${id}`);
        },
        finishAndEditReceipt(item) {
            this.finishData.allMoney = item.SurplusMoney.toFixed(2);
            this.finishData.orderId = item.EntpCusOId;
            this.finishData.payType = item.PayType;
            this.finishVisible = true;
        },
        closeFinish(edit) {
            this.finishVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        resetSearch() {
            this.searchData = {
                State: '',
                PayType: [],
                Keyword: '',
                DeliveryStat: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/RevenueManagement/GetOrdersReceivableList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    if (this.searchData.page == 1) {
                        this.statData.saleCount = data.SaleCount;
                        this.statData.saleTotal = data.SaleTotal;
                        this.statData.discountTotal = data.DiscountTotal;
                        this.statData.transTotal = data.TransTotal;
                        this.statData.orderTotal = data.OrderTotal;
                        this.statData.coseTotal = data.CoseTotal;
                        this.statData.profitTotal = data.ProfitTotal;
                        this.statData.receiptTotal = data.ReceiptTotal;
                        this.tableDataLength = res.count;
                    }

                    this.tableData = data.SaleOrderList;
                });
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.add('see', event);
            }
        },
        stateBack(item) {
            let that = this;
            if (item.EntpCusOId) {
                that.$confirm('您确定要将完成收款的状态回退成未完成收款状态吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/SaleOrderStateBack',
                                data: {
                                    orderId: item.EntpCusOId,
                                    userId: that.userMsg.EmployeeId
                                }
                            })
                            .then(res => {
                                that.$util.successMsg('状态回退成功');
                                that.getTableData();
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            } else {
                that.$util.warningMsg('订单信息异常，请刷新后重新操作');
            }
        },
        // 打印
        print() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }

            this.dialogVisible = true;
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'OrderCode':
                            this.columnShowSets.OrderCode.IsShow = item.IsShow;
                            this.columnShowSets.OrderCode.Width = item.Width;
                            this.columnShowSets.OrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnOrderRs':
                            this.columnShowSets.ReturnOrderRs.IsShow = item.IsShow;
                            this.columnShowSets.ReturnOrderRs.Width = item.Width;
                            this.columnShowSets.ReturnOrderRs.ColumnName = item.ColumnName;
                            break;
                        case 'EntpCusName':
                            this.columnShowSets.EntpCusName.IsShow = item.IsShow;
                            this.columnShowSets.EntpCusName.Width = item.Width;
                            this.columnShowSets.EntpCusName.ColumnName = item.ColumnName;
                            break;
                        case 'CallNum':
                            this.columnShowSets.CallNum.IsShow = item.IsShow;
                            this.columnShowSets.CallNum.Width = item.Width;
                            this.columnShowSets.CallNum.ColumnName = item.ColumnName;
                            break;
                        case 'CollectionStateName':
                            this.columnShowSets.CollectionStateName.IsShow = item.IsShow;
                            this.columnShowSets.CollectionStateName.Width = item.Width;
                            this.columnShowSets.CollectionStateName.ColumnName = item.ColumnName;
                            break;
                        case 'OutWarehouseStateName':
                            this.columnShowSets.OutWarehouseStateName.IsShow = item.IsShow;
                            this.columnShowSets.OutWarehouseStateName.Width = item.Width;
                            this.columnShowSets.OutWarehouseStateName.ColumnName = item.ColumnName;
                            break;
                        case 'OrderAmount':
                            this.columnShowSets.OrderAmount.IsShow = item.IsShow;
                            this.columnShowSets.OrderAmount.Width = item.Width;
                            this.columnShowSets.OrderAmount.ColumnName = item.ColumnName;
                            break;
                        case 'PayTypeName':
                            this.columnShowSets.PayTypeName.IsShow = item.IsShow;
                            this.columnShowSets.PayTypeName.Width = item.Width;
                            this.columnShowSets.PayTypeName.ColumnName = item.ColumnName;
                            break;
                        case 'DiscountAmount':
                            this.columnShowSets.DiscountAmount.IsShow = item.IsShow;
                            this.columnShowSets.DiscountAmount.Width = item.Width;
                            this.columnShowSets.DiscountAmount.ColumnName = item.ColumnName;
                            break;
                        case 'ShipAmount':
                            this.columnShowSets.ShipAmount.IsShow = item.IsShow;
                            this.columnShowSets.ShipAmount.Width = item.Width;
                            this.columnShowSets.ShipAmount.ColumnName = item.ColumnName;
                            break;
                        case 'CalcAmount':
                            this.columnShowSets.CalcAmount.IsShow = item.IsShow;
                            this.columnShowSets.CalcAmount.Width = item.Width;
                            this.columnShowSets.CalcAmount.ColumnName = item.ColumnName;
                            break;
                        case 'TotalCost':
                            this.columnShowSets.TotalCost.IsShow = item.IsShow;
                            this.columnShowSets.TotalCost.Width = item.Width;
                            this.columnShowSets.TotalCost.ColumnName = item.ColumnName;
                            break;
                        case 'TotalProfit':
                            this.columnShowSets.TotalProfit.IsShow = item.IsShow;
                            this.columnShowSets.TotalProfit.Width = item.Width;
                            this.columnShowSets.TotalProfit.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnMoney':
                            this.columnShowSets.ReturnMoney.IsShow = item.IsShow;
                            this.columnShowSets.ReturnMoney.Width = item.Width;
                            this.columnShowSets.ReturnMoney.ColumnName = item.ColumnName;
                            break;
                        case 'Paid':
                            this.columnShowSets.Paid.IsShow = item.IsShow;
                            this.columnShowSets.Paid.Width = item.Width;
                            this.columnShowSets.Paid.ColumnName = item.ColumnName;
                            break;
                        case 'SName':
                            this.columnShowSets.SName.IsShow = item.IsShow;
                            this.columnShowSets.SName.Width = item.Width;
                            this.columnShowSets.SName.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        batchComfirms() {
            let that = this;
            if (that.idList.length > 0) {
                for (let i = 0; i < that.idList.length; i++) {
                    let rec = that.tableData.find(x => x.EntpCusOId == that.idList[i]);
                    if (rec) {
                        if (rec.IsPay) {
                            this.$util.warningMsg(`第${i+1}张单【${rec.OrderCode}】已付款，不可操作`);
                            return false;
                        } else if (!rec.IsDelivery) {
                            this.$util.warningMsg(`第${i+1}张单【${rec.OrderCode}】未出仓，不可操作`);
                            return false;
                        }
                        if(rec.Paid!=0&&rec.Paid!=rec.SurplusMoney){
                            this.$util.warningMsg(`第${i+1}张单【${rec.OrderCode}】“已收定金”或者申请收款的金额不等于应收金额，请重新确认`);
                            return false;
                        }
                    }
                }
                that.$confirm('您确定要将选中数据进行批量确认吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        let confirmFormData = {
                            OrderIds: that.idList
                        };
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/SOBatchConfirmReceipt',
                                data: confirmFormData
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    that.$util.successMsg('保存成功');
                                    that.idList = [];
                                    that.$refs.multipleTable.clearSelection();
                                    that.getTableData();
                                } else {
                                    this.$util.warningMsg(res.errmsg);
                                }
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            } else {
                that.$util.warningMsg('请先勾选订单再进行批量确认操作');
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
</style>
<style lang="less">
.salesgather-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
